import { createStandardAction } from 'typesafe-actions'
import { ICalculationResults } from 'types/ICalculationResults'

export const setCalculations = createStandardAction('calculations/set')<
  ICalculationResults
>()
